import React from "react";
import { FiEdit } from "react-icons/fi";
import cn from "../../../lib/cn";
import P from "../../../shared/typography/P";

const DraftLabelInput = ({
    label,
    required,
    errorMessage,
    labelClass,
    className,
    wrapperClassName,
    icon,
    iconChange,
    iconWrapperClass,
    value,
    onClick,
}) => {
    return (
        <>
            <div className={cn("mb-2 2xl:mb-3.2", wrapperClassName)}>
                <div
                    className={cn(
                        "relative border border-blue-50 rounded-sm px-2 py-1.5 md:py-1.5 focus-within:border-blue duration-300 box-border min-h-[48px]",
                        className
                    )}
                >
                    <div
                        role="button"
                        onClick={onClick}
                        className="absolute right-0.1 top-0.1 p-0.5 rounded-sm bg-primary text-white z-10"
                    >
                        <FiEdit size={27} />
                    </div>
                    {label && (
                        <P
                            className={cn(
                                "text-xs lg:text-sm font-urbanist absolute left-1.8 -top-1 bg-white px-0.8 flex items-center gap-0.5",
                                labelClass
                            )}
                        >
                            {label}
                        </P>
                    )}

                    <div
                        className={`text-sm lg:text-base text-gray-secondary placeholder:text-gray-550 border-none outline-none h-full w-full transition-all duration-300 font-vietnam relative max-h-[200px] overflow-auto `}
                    >
                        <div
                            className="text-primary list-disc"
                            dangerouslySetInnerHTML={{
                                __html: value,
                            }}
                        ></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DraftLabelInput;
